// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + {"212":"wp-content/themes/mnrs/dist/css/style","276":"wp-content/themes/mnrs/dist/css/_variables","380":"/wp-content/themes/mnrs/dist/js/main","676":"wp-content/themes/mnrs/dist/css/_pallet","876":"wp-content/themes/mnrs/dist/css/features/breakpoint-debugging/style"}[chunkId] + ".css";
};